import * as RT from '@radix-ui/react-tooltip';
import type { ReactNode } from 'react';
import { useChromeDirection } from '@/lib/i18n/useLocale';

export function TooltipProvider({ children }: { children: ReactNode }) {
  return <RT.Provider delayDuration={250}>{children}</RT.Provider>;
}

export function Tooltip({ content, children }: { content: ReactNode; children: ReactNode }) {
  // Portalled to <body>: carry the chrome direction onto the bubble explicitly.
  const dir = useChromeDirection();
  return (
    <RT.Root>
      <RT.Trigger asChild>{children}</RT.Trigger>
      <RT.Portal>
        <RT.Content
          dir={dir}
          sideOffset={6}
          className="z-[95] max-w-xs rounded-sm border border-hairline bg-ink-navy px-sm py-xs text-small text-canvas-paper shadow-nav-scrolled"
        >
          {content}
          <RT.Arrow className="fill-ink-navy" />
        </RT.Content>
      </RT.Portal>
    </RT.Root>
  );
}
